import { useEffect, useRef, useState } from "react";
import { Pause, Play } from "lucide-react";

export const ESCENAS = [
  { src: "/hero/6-atardecer", ojo: "Agro paraguayo", titulo: "El campo, bajo control", pos: "60% 60%", kb: "a" },
  { src: "/hero/1-aereo", ojo: "Catastro SNC", titulo: "Cada parcela, medida y verificada", pos: "50% 50%", kb: "b" },
  { src: "/hero/3-pulverizacion", ojo: "Sentinel-2 · NDVI", titulo: "Vigilancia satelital de tu cartera", pos: "45% 60%", kb: "c" },
  { src: "/hero/2-cosecha", ojo: "Ciclo de siembra", titulo: "Del cultivo a la cosecha", pos: "55% 55%", kb: "a" },
  { src: "/hero/4-lluvia", ojo: "Clima y riesgo", titulo: "Lluvia, sequía y cultivo, al día", pos: "50% 40%", kb: "b" },
  { src: "/hero/5-silos", ojo: "TierraScore", titulo: "Datos del catastro + satélite, en un solo lugar", pos: "40% 55%", kb: "c" },
];
const MS = 5500;

const useReducido = () => {
  const [r, setR] = useState(() => window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  useEffect(() => {
    const m = window.matchMedia("(prefers-reduced-motion: reduce)");
    const f = (e) => setR(e.matches);
    m.addEventListener("change", f);
    return () => { m.removeEventListener("change", f); };
  }, []);
  return r;
};

const Capa = ({ e, on, prio }) => <picture>
  <source type="image/webp" srcSet={`${e.src}-m.webp 960w, ${e.src}.webp 1920w`} sizes="100vw" />
  <img src={`${e.src}.webp`} alt="" decoding="async" fetchpriority={prio ? "high" : "low"} loading={prio ? "eager" : "lazy"}
    className={`hc-img hc-kb-${e.kb} ${on ? "on" : ""}`} style={{ objectPosition: e.pos }} />
</picture>;

/** Portada cinematográfica: fotos reales con Ken Burns + crossfade, pausa y prefers-reduced-motion. */
export function useHero() {
  const reducido = useReducido();
  const [i, setI] = useState(0);
  const [pausa, setPausa] = useState(false);
  const [vistas, setVistas] = useState(() => new Set([0]));
  useEffect(() => {
    if (reducido || pausa) return undefined;
    const t = setTimeout(() => setI((x) => (x + 1) % ESCENAS.length), MS);
    return () => { clearTimeout(t); };
  }, [i, pausa, reducido]);
  useEffect(() => { setVistas((v) => (v.has((i + 1) % ESCENAS.length) ? v : new Set([...v, i, (i + 1) % ESCENAS.length]))); }, [i]);
  return { i: reducido ? 0 : i, setI, pausa, setPausa, vistas, reducido };
}

export function HeroFondo({ h }) {
  const ref = useRef(null);
  useEffect(() => {
    if (h.reducido || !window.matchMedia("(pointer: fine)").matches) return undefined;
    const f = (e) => {
      const el = ref.current;
      if (el) { el.style.setProperty("--px", `${(e.clientX / window.innerWidth - 0.5) * -14}px`); el.style.setProperty("--py", `${(e.clientY / window.innerHeight - 0.5) * -10}px`); }
    };
    window.addEventListener("pointermove", f);
    return () => { window.removeEventListener("pointermove", f); };
  }, [h.reducido]);
  return <div className={`hc-root ${h.pausa || h.reducido ? "hc-quieto" : ""}`} aria-hidden data-testid="hero-fondo">
    <div ref={ref} className="hc-par">{ESCENAS.map((e, k) => (h.reducido ? k === 0 : h.vistas.has(k)) && <Capa key={e.src} e={e} on={k === h.i} prio={k === 0} />)}</div>
    <div className="hc-scrim" /><div className="hc-grano" />
  </div>;
}

export function HeroTexto({ h }) {
  const e = ESCENAS[h.i];
  return <div className="space-y-3" data-testid="hero-texto">
    <p key={`o${h.i}`} className="hc-txt hc-ojo text-[11px] sm:text-xs font-semibold uppercase tracking-[0.28em] text-[#f3c46a]" data-testid="hero-eyebrow">{e.ojo}</p>
    <h2 key={`t${h.i}`} className="hc-txt font-['Sora'] font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.08] max-w-xl min-h-[2.2em]" style={{ "--d": ".08s" }} data-testid="hero-titulo">{e.titulo}</h2>
  </div>;
}

export function HeroControles({ h }) {
  if (h.reducido) return null;
  return <div className="flex items-center gap-3" data-testid="hero-controles">
    <button type="button" onClick={() => h.setPausa(!h.pausa)} aria-label={h.pausa ? "Reanudar" : "Pausar"} className="hc-pausa" data-testid="hero-pausa">
      {h.pausa ? <Play className="w-3.5 h-3.5" /> : <Pause className="w-3.5 h-3.5" />}</button>
    <div className="hc-pildora flex gap-1.5">{ESCENAS.map((e, k) => <button key={e.src} type="button" onClick={() => h.setI(k)} aria-label={`Escena ${k + 1}`} className={`hc-dot ${k === h.i ? "on" : ""}`} data-testid={`hero-dot-${k}`} />)}</div>
  </div>;
}
